<template>
  <Modal icon="fire" :title="$t('modals.promocode.title')" @close="$emit('close')">
    <template #text>
      <div class="social-modal__text">{{ $t('modals.promocode.text') }}</div>
    </template>
    <template #footer>
      <div class="social-modal__footer">
        <a :href="tgUrl" target="_blank">
          <Button>
            <img :src="require('@/assets/images/help/telegram.svg')" alt="" />
          </Button>
        </a>
        <a :href="vkUrl" target="_blank">
          <Button>
            <img :src="require('@/assets/images/help/vk.svg')" alt="" />
          </Button>
        </a>
        <a :href="youtubeUrl" target="_blank">
          <Button>
            <img :src="require('@/assets/images/help/youtube.svg')" alt="" />
          </Button>
        </a>
      </div>
    </template>
  </Modal>
</template>

<script>
import './promocode.scss'
import Modal from '@/components/Base/Modal/modal.vue'
import Button from '@/components/Base/Button/Button.vue'
import social from '@/mixins/social'

export default {
  name: 'PromocodeModal',
  mixins: [social],
  components: {
    Button,
    Modal
  }
}
</script>
